// Milestone slug for the v3→v2 opt-out survey responses (sent to the
// retailer satisfaction survey backend). The modal itself opens on every
// switch — there is no cooldown — because we want the June 30 permanence
// notice in front of users every time they revert, and the v3→v2 opt-out
// itself already auto-expires after 24h via useNavV3Gate.
export const NAV_V3_OPT_OUT_SURVEY_MILESTONE_SLUG = 'nav_v3_opt_out_r2026_05'
